import React, { Component } from "react";
import './user-drawer.less'
import { jumpPage } from '@/utils/common'
// 图片
import logo from "@/image/common/logo.svg";
import close from "@/image/common/close.svg";

interface Props {
  parentFunc: Function;
}

interface State {
  pageClass: string;
}

export default class UserDrawer extends Component<Props, State> {
// const UserDrawer = () => {
  refs: any = React.createRef()
  constructor(props: Props) {
    super(props)

    this.state = {
      pageClass: 'user-drawer-page close-user-drawer-page',
    }
  }

  closePage() {
    this.setState({
      pageClass: 'user-drawer-page close-user-drawer-page'
    })
  }

  render() {
    return (
      <section className={this.state.pageClass}>
        <>
          <header>
            <img src={logo} className="logo" alt="" />
            <img src={close} className="close" alt="" onClick={this.closePage.bind(this)} />
          </header>

          <ul className="cell-list">
            <li onClick={jumpPage.bind(this, '/')}><span>首页</span></li>
            <li onClick={jumpPage.bind(this, '/about-us')}><span>关于我们</span></li>
            <li onClick={jumpPage.bind(this, '/contact-us')}><span>联系我们</span></li>
          </ul>
        </>
      </section>
    )
  }
}
